import { Days } from '@appTypes';

export const defaultDateOptions: Days[] = [1, 8, 15, 25];
export const customPaymentDateId = 0;
export const threeWeeks = 21;
